import { Controller } from "@hotwired/stimulus"

// Reads a chosen image file, resizes it on a canvas (max 256px) to a small
// JPEG data-URL, writes it to the hidden basic.photo field, and fires autosave.
export default class extends Controller {
  static targets = ["input", "value", "preview"]

  pick(event) {
    const file = event.target.files && event.target.files[0]
    if (!file) return
    const reader = new FileReader()
    reader.onload = (e) => {
      const img = new Image()
      img.onload = () => {
        const max = 256
        let { width, height } = img
        if (width > height && width > max) { height = Math.round(height * max / width); width = max }
        else if (height > max) { width = Math.round(width * max / height); height = max }
        const canvas = document.createElement("canvas")
        canvas.width = width; canvas.height = height
        canvas.getContext("2d").drawImage(img, 0, 0, width, height)
        const url = canvas.toDataURL("image/jpeg", 0.82)
        this.valueTarget.value = url
        if (this.hasPreviewTarget) { this.previewTarget.src = url; this.previewTarget.style.display = "block" }
        this.valueTarget.dispatchEvent(new Event("input", { bubbles: true }))
      }
      img.src = e.target.result
    }
    reader.readAsDataURL(file)
  }

  remove() {
    this.valueTarget.value = ""
    if (this.hasPreviewTarget) { this.previewTarget.src = ""; this.previewTarget.style.display = "none" }
    this.valueTarget.dispatchEvent(new Event("input", { bubbles: true }))
  }
}
